.header {
  display: flex;
  border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
  gap: 1.6rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 2.4rem;
  font-weight: 500;
  box-sizing: border-box;
  border-bottom: 1px solid var(--color-grayscale-tuna);
  margin-bottom: 2.4rem;

  @media screen and (min-width: $bp-medium) {
    border-bottom: none;
    padding: 2.4rem;
    margin-bottom: 0;
  }
}

.action {
  cursor: pointer;
  font-weight: 500;
  font-size: 1.4rem;
  color: var(--color-primary-crayola);

  &[data-disabled='true'] {
    color: var(--color-shades-tropaz, #254f9f);
    pointer-events: none;
    user-select: none;
  }

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}

.close-item {
  @media screen and (min-width: $bp-medium) {
    order: 3;
  }
}
